import { thumbnail, placeholderThumb } from "../../../functions/thumbnail";

export default {
  props: {
    file: Object,
  },
  methods: {
    thumb(item, big = false) {
      //return thumbnail(item, big);

      return `/img/fileicons/small/png.svg`;
    },
  },
  computed: {
    onError() {
      return placeholderThumb();
    },
  },
};
